import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCarrier } from '../../api';
import { useAlert } from '../useAlert';

export default function useUpdateCarrier(handleClose) {
  const { showAlert } = useAlert();
  const queryClient = useQueryClient();
  const Request = useMutation({
    mutationFn: updateCarrier,
    mutationKey: 'updateCarrier',
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries('getCarrier');
      showAlert({
        type: 'success',
        message: data?.message ?? 'Carrier updated sucessfully',
      });
      handleClose();
    },
    onError: (error) => {
      const errMsg = error?.message ?? 'unexpected error';
      showAlert({ type: 'secondary', message: errMsg });
    },
  });
  return { ...Request };
}
